/**
 * Message Send Manager
 * 管理消息发送、乐观更新、失败回退等
 */

import { sendMessageNew } from '@/api/chat'
import { dbManager } from '@/indexdb/chat'
import { IMContentDecrypt } from '@/utils/crypto'

class MessageSendManager {
  constructor() {
    this.sendingMessages = new Map() // 正在发送的消息 Map<tempMsgId, promise>
  }

  /**
   * 发送消息（发送成功后写入DB）✅
   * @param {Object} params - 发送参数
   * @param {string} params.targetId - 接收者用户ID
   * @param {string} params.content - 消息内容
   * @param {string} params.msgType - 消息类型（默认 TextDef）
   * @returns {Promise<Object>} 服务端返回的消息对象
   */
  async sendMessage({ targetId, content, msgType }) {
    try {
      // 1. 调用发送接口
      const sendMsgResponse = await sendMessageNew({
        target_id: targetId,
        msg_type: msgType,
        content
      })
      // 接口返回的 msg_preview 居然是上一条的❗️❗️❗️❗️❗️❗️❗️服了
      const { content: rContent, conversation_id, created_at, msg_id,
         msg_source, send_uid, seq_id, sub_type } = sendMsgResponse
      const createdAt = Number(created_at)
      // 组装MsgBean
      const msgBean = {
        content: rContent,
        conversation_id,
        created_at: createdAt,
        msg_id,
        msg_preview: content, // TODO:现在暂时先用 content 代替 msg_preview，后续再优化(考虑是否在发送完后就插入db)
        msg_source,
        send_uid,
        seq_id,
        sub_type,
      }

      // 获取数据库实例
      const db = dbManager.getDatabase()
      if (!db) throw new Error('Database not initialized')

      // 使用事务保证原子性：保存消息、更新会话、更新游标
      await db.transaction('rw', db.messages, db.conversations, async () => {
        // 1. 保存消息到 DB
        await db.messages.put(msgBean)

        // 更新会话信息(如果是新会话，会话不存在，会话不会新建也不会报错，IM会推送新的会话消息，届时会创建会话)
        await db.conversations.update(msgBean.conversation_id, {
          unreadCount: 0,
          target_read_at: createdAt,
          last_msg_at: createdAt,
          preview: IMContentDecrypt(msgBean.msg_preview)
        })

        // 3. 更新 seq_id 游标

        // const cursor = await db.sync_cursor.get('cursor')
        // if (cursor) {
        //   const currentMax = cursor.lastSeqId ?? 0
        //   msgBean.seq_id > currentMax && await db.sync_cursor.update('cursor', {
        //     lastSeqId: msgBean.seq_id,
        //     lastSyncTime: Date.now()
        //   })
        // }
      })

      return msgBean

    } catch (error) {
      console.error('[MessageSend] Failed to send message:', error)
      throw error
    }
  }
}

// 导出单例
export const messageSendManager = new MessageSendManager()

export default MessageSendManager
